import React from "react";
import Modal from "../../../components/modal";
import {CancelButton, FlexContainer, SubmitButton, Text} from "../../../design";
import FileUploader from "./FileUploader";
import { Col, Row } from "react-awesome-styled-grid";
import { CheckCircleOutlined } from "@ant-design/icons";


const UploadConfirmationModal = (props) => {
  const { confirmationModal, onClose, selectedDocument, publicKeyUrl, setUploadedUrl, uploadedUrl, onSubmit } = props;
  return (
    <Modal isOpen={confirmationModal}>
        <FlexContainer
            height="400px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            box-shadow="0 0 20px 0 rgba(0, 0, 0, 0.1)"
            backdropFilter='none'
            borderRadius='4px'
            backgroundColor="#f2f5f8"
            textAlign='center'
            alignContent='none'
        >
              <Text
                fontSize="20px"
                fontWeight='600'
              >
              UPLOAD FILE
            </Text>
            <Text fontSize="16px" textAlign="center" paddingX="14px" className="mb-3">
              Upload the file for selected document type : {selectedDocument?.label}
            </Text>
            <FileUploader
              keyType="PAYPAL_VERIFICATION"
              endPoint="/storage/upload/kyc-document"
              setUrl={value => {
                setUploadedUrl(value);
              }}
              value={uploadedUrl}
              accept="application/pdf,image/*"
              type="Business"
              publicKeyUrl={publicKeyUrl}
            />
            {uploadedUrl && (
            <Row
              className="d-flex align-items-center mb-4"
              style={{
                  backgroundColor: 'white',
                  padding: '1rem',
                  borderRadius: '10px',
                  boxShadow: '0 0 0 1px #e0e0e0',
                  maxWidth: '315px',
                  width: '90%',
                  marginTop: '2rem',
              }}
            >
              <Col>
              <div style={{ fontWeight: 600, fontSize: '14px', color: '#000000' }}>
                  {selectedDocument?.label}
              </div>
              <div style={{ color: '#007ED4', fontSize: '13px', marginTop: '7px' }}>
                  Upload Complete
              </div>
              </Col>
              <Col>
                <CheckCircleOutlined style={{ color: '#00E38C', fontSize: '28px' }} />
              </Col>
            </Row>
            )} 
            <FlexContainer
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <CancelButton
                onClick={() => onClose()}
                type="button"
              >Cancel</CancelButton>
              <SubmitButton
                onClick={() => onSubmit()}
                type="button"
                disabled={!uploadedUrl}
              >Submit</SubmitButton>
            </FlexContainer>
      </FlexContainer>
    </Modal>
  )
};

export default UploadConfirmationModal;
